<template>
  <div class="search-bar">
    <standard-input
      :value="filter"
      type="search"
      label="Miasto, adres lub nazwa PS"
      :icon="true"
      @input_change="onInput($event)"
    >
      <svg svg-inline="" class="input-label-icon" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M20.083 8.532s-.065 0 0 0h-.065C13.668 8.532 8.55 13.715 8.55 20c0 6.35 5.183 11.468 11.468 11.468h.065c6.349 0 11.467-5.184 11.467-11.468A11.447 11.447 0 0 0 20.083 8.532zm.842 20.408v-3.109c0-.323-.323-.648-.648-.648h-.518c-.324 0-.648.325-.648.648v3.046a8.86 8.86 0 0 1-8.034-8.034h3.045c.324 0 .648-.324.648-.648v-.453c0-.324-.324-.648-.648-.648h-3.045c.389-4.276 3.823-7.645 8.099-8.034v3.044c0 .324.324.648.648.648h.453c.325 0 .648-.324.648-.648V11.06c4.275.453 7.645 3.822 8.098 8.034h-3.044c-.325 0-.648.324-.648.648v.453c0 .324.323.648.648.648h3.044c-.388 4.276-3.823 7.709-8.098 8.097z" fill="#111"/></svg>
    </standard-input>
  </div>
</template>

<script>
import StandardInput from '~/StandardInput';
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash';

export default {
  components: {
    StandardInput,
  },
  data() {
    return {
      filter: '',
    };
  },
  computed: {
    ...mapGetters({
      serviceStations: 'serviceStations/getServiceStations',
    }),
  },
  methods: {
    ...mapActions({
      filterServiceStations: 'serviceStations/filterServiceStations',
    }),
    // eslint-disable-next-line
    debounceFilter: debounce(function () {
      this.filterServiceStations(this.filter);
    }, 500),
    onInput(value) {
      this.filter = value;
      this.debounceFilter();
    },
  },
  mounted() {
    this.filterServiceStations(this.filter);
  },
};
</script>
